export default __webpack_public_path__ + "media/images/fancybox/fancy_shadow_w-99659321a6e53ebf56f3172d22161a22.png";